<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('polls.title')" icon="briefcase">
            <app-default-button
                v-if="$can('create_poll')"
                :title="$addLabel('poll')"
                @click="openPollModal()"
            />
        </app-page-top-section>

        <app-table
            id="poll-table"
            :options="options"
            @action="triggerActions"
        />

        <app-poll-modal
            v-if="isPollModalActive"
            v-model="isPollModalActive"
            :selected-url="selectedUrl"
            />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('poll-table')"
            @cancelled="cancelled"
        />


    </div>
</template>

<script>
import PollMixin from "../../../Mixins/Pms/PollMixin";
import {urlGenerator} from "../../../../../common/Helper/AxiosHelper";
import {POLL_WEB} from "../../../../Config/ApiUrl";

export default {
    name: "Polls",
    mixins: [PollMixin],
    data() {
        return {
            poll: '',
            pollsId: '',
            polls: [],
            selectedUrl: '',
            modalClass: '',
            promptIcon: '',
            promptSubtitle: '',
            isPollModalActive: false,
            confirmationModalActive: false,
        }
    },
    created() {
        this.$store.dispatch('getStatuses', 'polls')
    },
    watch: {
        isPollModalActive: function (value) {
            if (!value) {
                this.selectedUrl = '';
            }
        }
    },
    methods: {
        openPollModal() {
            this.selectedUrl = '';
            this.isPollModalActive = true;
        },
        triggerActions(row, action, active) {
            this.pollsId = row.id;
            this.promptIcon = action.icon;
            this.modalClass = action.modalClass;
            this.promptSubtitle = action.promptSubtitle;

            if (action.name === 'edit') {
                this.selectedUrl = `${action.url}/${row.id}`;
                this.isPollModalActive = true;
            }
            if (action.name === 'view_details') {
                this.selectedUrl = window.location = urlGenerator(`${action.url}/${row.id}`);
            }
            if (action.name === 'start_poll') {
                window.location.href = urlGenerator(`${action.url}/${row.id}/form`);
            }
            else {
                this.getAction(row, action, active)
            }
        },
        cancelled() {
            this.confirmationModalActive = false;
        },
    }
}
</script>
